import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { filter, pluck } from "rxjs/operators";
import { SessionStorageService } from '../storage/sessionStorage.service';
import { LocalService } from '../storage/localService';

@Injectable({
  providedIn: 'root'
})
export class CavaliService {
  readonly urlBase =  environment.rutaBase;
  //readonly urlBase =  "http://localhost:2528";

  header : HttpHeaders;

  idEmpresa_Factor: any;
  message: Observable<any>;

  constructor(private http : HttpClient,  
              private accesoService :AccesoService, 
              private sessionStorageService: SessionStorageService,
              private localService: LocalService) { 
    this.header = this.accesoService.desencriptarTOKEN(); 
    this.datoStorage();
  }

  datoStorage() {
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
    this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
    if (this.idEmpresa_Factor == undefined) {
      this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
    }
  }

  listarCavali(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  listarDNegociables(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali/Negociables?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  listarAdicionarInformacion(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali/Adicionar?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  listarAnotarCuenta(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali/Anotar?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  listarTransferenciaContable(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali/Transferir?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  listarRedimir(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali/Redimir?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  listarRetirar(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali/Retirar?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  registrarCavali(idComprobante:number){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/cavali?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`,[],{headers});
  }

  obtenerFNCavali(idComprobante:number){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali/Informacion?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`,{headers});
  }

  adicionarInformacionCavali(idComprobante:number){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/cavali/Adicionar?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`,[],{headers});
  }

  anotarCuentaCavali(idComprobante:number){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/cavali/Anotar?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`,[],{headers});
  }

  transferirCuentaCavali(idComprobante:number){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/cavali/Transferir?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`,[],{headers});
  }

  traspasoCavali(idComprobante:number){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/cavali/Traspaso?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`,[],{headers});
  }

  redirmirDocumentoCavali(idComprobante:number){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/cavali/Redimir?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`,[],{headers});
  }
  
  retirarDocumentoCavali(idComprobante:number){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/cavali/Retirar?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`,[],{headers});
  }

  downloadInformation(idComprobante:number){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali/Informacion?idEmpresa_Factor=${this.idEmpresa_Factor}&idComprobante=${idComprobante}`,{headers});
  }

  cronProceso(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali/Procesos?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  cronInformacion(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cavali/Informacion?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }
}